// src/services/globalTemplates.ts
//
// Global-templates-domain service. Manages the shared meal-plan template
// catalog: list, create, edit meal options and meal times, publish, rename,
// duplicate options, plus the suggest-plan flow (create suggestion, list
// pending/rejected suggestions, view details, approve/reject).

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getGlobalTemplateList = (
  page: number = 1,
  pageSize: number = 12,
  search: string = "",
  mealPlanType: string = "",
  mealsPerDay: string = "",
  optionsPerMeal: string = "",
  nutritionistIds: number[] = []
): Promise<any> =>
  handleJson(
    apiFetch(
      API_URLS.GET_GLOBAL_TEMPLATE_LIST(
        page,
        pageSize,
        search,
        mealPlanType,
        mealsPerDay,
        optionsPerMeal,
        nutritionistIds
      ),
      { method: "GET" }
    )
  );

export const createGlobalTemplate = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.CREATE_GLOBAL_TEMPLATE, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const createGlobalTemplateMealOptions = (
  templateId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.CREATE_GLOBAL_TEMPLATE_MEAL_OPTIONS(templateId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const updateGlobalTemplateMealOptions = (
  templateId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_GLOBAL_TEMPLATE_MEAL_OPTIONS(templateId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const deleteGlobalTemplateMealOptions = (
  templateId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.DELETE_GLOBAL_TEMPLATE_MEAL_OPTIONS(templateId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const updateGlobalTemplateMealTime = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_GLOBAL_TEMPLATE_MEAL_TIME, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const duplicateGlobalTemplateMealOptions = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.DUPLICATE_GLOBAL_TEMPLATE_MEAL_OPTIONS, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const publishGlobalTemplate = (
  templateId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.PUBLISH_GLOBAL_TEMPLATE(templateId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const updateTemplateName = (
  templateId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_TEMPLET_NAME(templateId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const suggestPlanGlobalTemplate = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.SUGGEST_PLAN_GLOBAL_TEMPLATE, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getSuggestedPlanGlobalTemplate = (
  status: string = "pending",
  page: number = 1,
  pageSize: number = 10,
  search: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(
      API_URLS.GET_SUGGESTED_PLAN_GLOBAL_TEMPLATE(status, page, pageSize, search),
      { method: "GET" }
    )
  );

export const getSuggestedPlanGlobalTemplateDetails = (
  suggestionId: string | number
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_SUGGESTED_PLAN_GLOBAL_TEMPLATE_DETAILS(suggestionId), {
      method: "GET",
    })
  );

export const approveSuggestion = (
  suggestionId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.APPROVE_SUGGESTION(suggestionId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const rejectSuggestion = (
  suggestionId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.REJECT_SUGGESTION(suggestionId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getRejectedSuggestions = (
  page: number = 1,
  pageSize: number = 10,
  search: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_REJECTED_SUGGESTIONS(page, pageSize, search), {
      method: "GET",
    })
  );
